/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { BeerPongTableEndpointService } from 'openapi-generated';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'beer-pong-table-create',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  providers: [],
  templateUrl: './beer-pong-table-create.component.html',
  styleUrl: './beer-pong-table-create.component.scss',
})
export class BeerPongTableCreateComponent implements OnInit {
  beerPongTableForm = new FormGroup({
    name: new FormControl('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(20),
      Validators.pattern(/^[\w\s.äÄöÖüÜ\-,#]*$/),
    ]),
  });
  tournamentId: number | null = null;

  constructor(
    private client: BeerPongTableEndpointService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.route.params.subscribe({
      next: params => {
        if (params.tournamentId) {
          this.tournamentId = Number.parseInt(params.tournamentId, 10);
        }
      },
    });
  }

  saveTournament() {
    this.beerPongTableForm.disable();

    this.client
      .createBeerPongTable({
        name: this.beerPongTableForm.controls.name.value ?? '',
        tournamentId: this.tournamentId!,
      })
      .subscribe({
        next: () => {
          this.snackBar.open('Successfully created new beer pong table', 'Close', {
            duration: 3000,
          });
          this.router.navigate(['..'], { relativeTo: this.route });
        },
        error: async (er: HttpErrorResponse) => {
          this.snackBar.open(
            typeof er.error === 'string'
              ? er.error
              : `There was a problem creating the beer pong table: ${await er.error.text()}`,
            'Close',
            { duration: 3000 },
          );
          this.beerPongTableForm.enable();
        },
      });
  }

  createBeerPongTable() {
    if (this.beerPongTableForm.valid && this.tournamentId !== null) {
      this.saveTournament();
    }
  }
}
